module.exports = __webpack_public_path__ + "static/media/art19.9f635fe4.jpg";